<template>
  <div class="animated fadeIn">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <b-col sm="12" lg="8" class="pt-2 p-1 title">
              <span :title="corporationSelected && corporationSelected.name">Ativações e Renovações - {{corporationSelected && corporationSelected.name}}</span>
            </b-col>
          </div>
          <b-form @submit.stop.prevent>
            <b-form-group label="Início" label-for="txt-data-inicio">
              <b-form-input type="date" id="txt-data-inicio" v-model="filters.initDate" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
            </b-form-group>

            <b-form-group label="Fim" label-for="txt-data-fim">
              <b-form-input type="date" id="txt-data-fim" v-model="filters.endDate" class="mb-1 mr-sm-1 mb-sm-0"></b-form-input>
            </b-form-group>

            <b-form-group label="Tipo de evento" label-for="sel-event-type">
              <b-form-select id="sel-event-type" v-model="filters.eventType" :options="eventTypes" class="mb-1 mr-sm-1 mb-sm-0"></b-form-select>
            </b-form-group>

            <b-form-group label="Tipo de usuário" label-for="sel-user-class">
              <b-form-select id="sel-user-class" v-model="filters.userClass" :options="userClasses" class="mb-1 mr-sm-1 mb-sm-0"></b-form-select>
            </b-form-group>

            <b-form-group label="" label-for="all-corporations" v-if="canGetAllCorporations()">
              <b-form-checkbox id="all-corporations" v-model="filters.allCorporations" name="all-corporations">
                Consolidar todas as corporações
              </b-form-checkbox>
            </b-form-group>

            <div slot="footer">
              <b-row>
                <b-col sm="12" lg="2">
                  <b-button variant="primary" class="form-control" @click="getActivationsAndRenovations">Visualizar</b-button>
                </b-col>
                <b-col sm="12" lg="2">
                  <b-button variant="secondary" class="form-control" @click="download">Download</b-button>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </b-card>
      
        <p></p>
        <b-table id="result-table" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm"
          :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage">
          <template slot="id" slot-scope="data">
            <strong>{{data.item.id}}</strong>
          </template>
          <template slot="username" slot-scope="data">
            <strong>{{data.item.username}}</strong>
          </template>
          <template slot="userClass" slot-scope="data">{{getUserClassLabel(data.item.userClass)}}</template>
          <template slot="creationDate" slot-scope="data">{{formatDate(data.item.creationDate.date)}}</template>
          <template slot="expirationDate" slot-scope="data">{{data.item.expirationDate && formatDate(data.item.expirationDate.date)}}</template>
          <template slot="eventType" slot-scope="data"><span :title="data.item.eventType">{{getTypeName(data.item.eventType)}}</span></template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="result-table"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex';
import { requestError, env, formatDate, isAllowed } from '@/shared/utils'
import _ from 'underscore'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'report_activations',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Usuários'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      filters: {
        eventType: '',
        userClass: ''
      },
      items: [],
      perPage: 30,
      currentPage: 1,
      eventTypes: [
        {value: '', text: 'Todos eventos'},
        {value: 'activation', text: 'Ativação'},
        {value: 'auto_renovation', text: 'Renovação automática'},
        {value: 'manual_renovation', text: 'Renovação manual'},
        {value: 'seat_fill', text: 'Substituição'}
      ],
      userClasses: [
        {value: '', text: 'Todos usuários'},
        {value: 'user_corporation', text: 'Corporativo'},
        {value: 'user_signer', text: 'Assinante PJ'}
      ],
      loadCount: 0,
    }
  },
  async mounted() {
    // await this.initialize();
  },
  computed: {
    ...mapState(['corporationSelected']),
    isLoading() {
      return this.loadCount > 0;
    },
    fields() {
      let fields = [];
      if (this.items && this.items.length > 0 && this.items[0].corporation_name) {
        fields.push({key: 'corporation_name', label: 'Corporação'})
      }
      fields.push(...[
        {key: 'username', label: 'CPF/CNPJ'},
        {key: 'name', label: 'Nome'},
        {key: 'userClass', label: 'Tipo'},
        {key: 'creationDate', label: 'Criação'},
        {key: 'expirationDate', label: 'Expiração'},
        {key: 'eventType', label: 'Evento'}
      ])
      return fields;
    },
    rows() {
      return this.items ? this.items.length : 0;
    }
  },
  methods: {
    formatDate(date) {
      return formatDate(date, "dd/MM/yyyy");
    },
    getTypeName(type) {
      switch (type) {
        case "activation":
          return "Ativação";
        case "manual_renovation":
          return "Renovação";
        case "auto_renovation":
          return "Renovação"
        case "seat_fill":
          return "Substituição"
        default:
          return "";
      }
    },
    getUserClassLabel(userClass) {
      switch (userClass) {
        case 'user_signer':
          return "Assinante PJ"
        default:
          return "Corporativo"
      }
    },
    async getActivationsAndRenovations() {
      if (!this.validate()) {
        return;
      }
      var _this = this;
      this.loadCount++;
      await axios
        .get(this.getUrl())
        .then(function(response) {
          _this.items = response.data._embedded.report_activation;
          console.log(response.data);
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    validate() {
      if (!this.filters.initDate || !this.filters.endDate) {
        alert("O período deve ser informado!");
        return false;
      }
      let diffDays = (new Date(this.filters.endDate) - new Date(this.filters.initDate)) / 1000 / 60 / 60 / 24;
      let limit = this.filters.allCorporations ? 30 : 90;
      if (diffDays > limit) {
        alert(`O período não deve exceder a ${limit} dias.`);
        return false;
      }
      return true;
    },
    async download () {
      if (!this.validate()) {
        return;
      }
      var _this = this;
      this.loadCount++;
      var format = "csv";
      await axios
        .get(this.getUrl(format),
          { responseType: 'arraybuffer' })
        .then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const fileName = `report-activation-${+ new Date()}.${format}`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    },
    getUrl(format = null) {
      let url = `${env.urlBillingApi}/report-activation?initDate=${this.filters.initDate}&endDate=${this.filters.endDate}&eventType=${this.filters.eventType}`;
      if (format) {
        url += `&report=true&format=${format}`;
      }
      if (this.filters.allCorporations) {
        url += `&consolidated=true`;
      }
      if (this.filters.userClass) {
        url += `&userClass=${this.filters.userClass}`;
      }
      return url;
    },
    canGetAllCorporations() {
      return isAllowed('corporation_manager');
    },
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-usuarios-atual, #card-chart-usuarios-total, #card-chart-usuarios-pico, #card-chart-usuarios-ativos, #volumes-chart {
    width: 100% !important;
  }
</style>

<style scoped>
  .title {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>